export const hasProjectConfigMenuElements = projectConfig => {
  const menu = projectConfig?.data?.menu;
  const elements = menu?.elements;
  const secondaryElements = menu?.secondary_elements;

  return (
    (Array.isArray(elements) && elements.length > 0) ||
    (Array.isArray(secondaryElements) && secondaryElements.length > 0)
  );
};

export const shouldRefreshProjectConfig = (projectConfig, user) => {
  if (!user?.logged) {
    return false;
  }

  return !projectConfig?.data?.id || !hasProjectConfigMenuElements(projectConfig);
};

export const getProjectConfigRequestData = (user, refreshKey = 'initial') => {
  if (!user?.logged) {
    return {};
  }

  return {
    refreshProjectConfig: `${refreshKey}-${user?.username || 'anonymous'}`,
  };
};
